import { createInboxEventStream } from '@/lib/inbox-event-stream'
import { requireExpertApiUser } from '@/lib/role-guard'

export async function GET() {
  const guard = await requireExpertApiUser()
  if (!guard.ok) return guard.response

  const stream = createInboxEventStream({ tenantId: guard.user.tenantId })

  return new Response(stream, {
    headers: {
      'Content-Type': 'text/event-stream',
      'Cache-Control': 'no-cache, no-transform',
      Connection: 'keep-alive',
      'X-Accel-Buffering': 'no',
    },
  })
}
